// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__IXhl7","copyright":"Footer_copyright__wUgl9"};